class SmoothScroll {
    constructor(){
        
        // handle links with @href started with '#' only
        jQuery('a[href*="#"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .click( function(e) {
            // target element id
            jQuery("#menu-main-menu .menu-item a").removeClass("active");
            jQuery(this).addClass("active");
            let menuItem = jQuery(this);
            // console.log(this.hostname);
            let id = menuItem.attr('href');
            // console.log(id);
            // console.log(jQuery(this.hash))
            // jQuery("nav.navbar li a").css({
            //     "color":"#000"
            // });
            // jQuery("nav.navbar li.contact a").css({
            //     "color":"#fff"
            // });
            // menuItem.css({
            //     "color":"#7e7d00"
            // });
            // target element
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
                && 
                location.hostname == this.hostname
              ) {
                var target = jQuery(this.hash);
                target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
    
              }
          
            var jQueryid = jQuery(target);
            if (jQueryid.length === 0) {
                return;
            }

            // prevent standard hash navigation (avoid blinking in IE)
            e.preventDefault();

            // top position relative to the document
            var pos = jQueryid.offset().top;

            // animated top scrolling
            jQuery('body, html').animate({scrollTop: pos});
        });
        jQuery(window).on('scroll', function(){
            // jQuery("#menu-main-menu .menu-item a").removeClass("active");
           let scroll =  jQuery(window).scrollTop();
           if(scroll > 500){
            jQuery("#back-to-top").show();
           }else{
            jQuery("#back-to-top").hide();
           }
        } );
        // jQuery(window).scroll(function (event) {
        //     let scroll = jQuery(window).scrollTop();
        //     // Do something
        //     this.console.log(scroll);
        // });
        // jQuery("#back-to-top").on('click', ()=>alert('hi')) ;

        // Cache selectors
        jQuery(window).on('scroll', function() {
            
            let position = jQuery(this).scrollTop() + 140;
            jQuery('.wp-block-group').each(function() {
                var target = jQuery(this).offset().top;
                var id = jQuery(this).attr('id');
                if(id !== undefined){
                    if (position >= target) {
                        jQuery("#menu-main-menu .menu-item a").removeClass("active");
                        jQuery('#menu-main-menu li a').removeClass('active');
                        jQuery('#menu-main-menu li a[href*=#' + id + ']').addClass('active');
                    }
                }
             
            });
        });

    }
}

export default SmoothScroll;